export var RankedCarrierType;
(function (RankedCarrierType) {
    RankedCarrierType[RankedCarrierType["CARRIER_IATA"] = 0] = "CARRIER_IATA";
    RankedCarrierType[RankedCarrierType["CARRIER_ICAO"] = 1] = "CARRIER_ICAO";
    RankedCarrierType[RankedCarrierType["CARRIER_NAME"] = 2] = "CARRIER_NAME";
    RankedCarrierType[RankedCarrierType["CARRIER_SCAC"] = 3] = "CARRIER_SCAC";
    RankedCarrierType[RankedCarrierType["CARRIER_US_DOT_NUMBER"] = 4] = "CARRIER_US_DOT_NUMBER";
    RankedCarrierType[RankedCarrierType["CARRIER_MC_NUMBER"] = 5] = "CARRIER_MC_NUMBER";
})(RankedCarrierType || (RankedCarrierType = {}));
